import React, { useEffect, useRef } from 'react';

function AdsenseAd() {
  const adRef = useRef(null);
  useEffect(() => {
    if (window.adsbygoogle && adRef.current) {
      try {
        window.adsbygoogle.push({});
      } catch (e) {
        console.log(e);
      }
    }
  }, []);
  return (
    <div
      style={{
        maxWidth: 728,
        width: '100%',
        height: 90,
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', height: 90 }}
        data-ad-client="ca-pub-1705107311727286"
        data-ad-slot="6806214369"
        ref={adRef}
      />
    </div>
  );
}

export default AdsenseAd;
